import { lazy } from "react";
// Note: make sure path is in lower case

export const ROUTES = {
  LOGIN: "/",
  DASHBOARD: "/dashboard",
  SETUP_STEP_1: "/setup/:patientId/1",
  SETUP_STEP_2: "/setup/:patientId/2",
  SETUP_STEP_3: "/setup/:patientId/3",
  SETUP_STEP_4: "/setup/:patientId/4",
  SETUP_COMPLETE: "/setup/:patientId/complete",
} as const;

// Step mapping (4 steps total):
// /1 → Step1Account   (create account)
// /2 → Step3Device    (OCR + portal)
// /3 → Step4Verify (hidden when FIELD_SETUP_VERIFY_STEP_ENABLED is false in fieldSetupFlags.ts)
// /4 → Step5Handover  (patient handover)

export const routes = {
  login: {
    index: true,
    element: lazy(() => import("../../pages/Login")),
  },
  dashboard: {
    path: ROUTES.DASHBOARD,
    element: lazy(() => import("../../pages/Dashboard")),
  },
  setupStep1: {
    path: ROUTES.SETUP_STEP_1,
    element: lazy(() => import("../../pages/Setup/Step1Account")),
  },
  setupStep2: {
    path: ROUTES.SETUP_STEP_2,
    element: lazy(() => import("../../pages/Setup/Step3Device")),
  },
  setupStep3: {
    path: ROUTES.SETUP_STEP_3,
    element: lazy(() => import("../../pages/Setup/Step4Verify")),
  },
  setupStep4: {
    path: ROUTES.SETUP_STEP_4,
    element: lazy(() => import("../../pages/Setup/Step5Handover")),
  },
  setupComplete: {
    path: ROUTES.SETUP_COMPLETE,
    element: lazy(() => import("../../pages/Complete")),
  },
  catchAll: {
    path: "*",
    element: lazy(() => import("./CatchAllRedirect")),
  },
} as const;
